import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/cursor_left_bottom.png'


const _hoisted_1 = { class: "pantry-recommend-main-view" }
const _hoisted_2 = { class: "pantry-recommend-main-view-list-area" }
const _hoisted_3 = { class: "pantry-recommend-main-view-top-view" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pantry-recommend-main-view-top-view-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "commonTextBodyStrong pantry-recommend-main-view-title-text" }, "おすすめレシピ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-recommend-main-view-image-icon",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_CommonRecipeList, {
          recipes: _ctx.recipes,
          onSelectRecipe: _ctx.selectRecipe
        }, null, 8, ["recipes", "onSelectRecipe"])
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", {
        class: "pantry-recommend-main-view-image",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBack(...args)))
      }, [
        _hoisted_5
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}